var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4121 10V30.5882H80.0004V10H59.4121ZM75.8827 26.4706H63.5298V14.1176H75.8827V26.4706Z",
    fill: "#121B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6475 18.2354H71.7651V22.353H67.6475V18.2354Z",
    fill: "#121B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4121 80H80.0004V59.4117H59.4121V80ZM63.5298 63.5294H75.8827V75.8823H63.5298V63.5294Z",
    fill: "#121B26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6475 67.6471H71.7651V71.7647H67.6475V67.6471Z",
    fill: "#121B26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 80H30.5882V59.4117H10V80ZM14.1176 63.5294H26.4706V75.8823H14.1176V63.5294Z",
    fill: "#121B26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2354 67.6471H22.353V71.7647H18.2354V67.6471Z",
    fill: "#121B26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7061 75.8823H45.0002V80H34.7061V75.8823Z",
    fill: "#121B26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7061 67.6471H40.8825V71.7647H34.7061V67.6471Z",
    fill: "#121B26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3525 51.1765H26.4702V55.2942H22.3525V51.1765Z",
    fill: "#121B26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2353 51.1765H14.1176V42.9412H10V55.2941H18.2353V51.1765Z",
    fill: "#121B26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8823 51.1765H71.7646V55.2941H79.9999V42.9412H75.8823V51.1765Z",
    fill: "#121B26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4121 51.1765H67.6474V55.2942H59.4121V51.1765Z",
    fill: "#121B26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51.1765H55.2941V55.2942H45V51.1765Z",
    fill: "#121B26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1172 75.8823H55.2937V80H49.1172V75.8823Z",
    fill: "#121B26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1765 67.647H45V71.7647H55.2941V59.4117H51.1765V67.647Z",
    fill: "#121B26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7054 63.5295H44.9995V59.4118H38.823V51.1765H30.5879V55.2942H34.7054V63.5295Z",
    fill: "#121B26"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1172 18.2354H55.2937V22.353H49.1172V18.2354Z",
    fill: "#121B26"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4121 34.7059H63.5298V38.8236H59.4121V34.7059Z",
    fill: "#121B26"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4121 42.9412H63.5298V47.0588H59.4121V42.9412Z",
    fill: "#121B26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6475 47.0589H71.7651V38.8236H80.0004V34.7059H67.6475V47.0589Z",
    fill: "#121B26"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30.5882H51.1765V47.0588H55.2941V26.4706H45V30.5882Z",
    fill: "#121B26"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4707 47.0588H45.0001V42.9411H30.5883V38.8235H26.4707V47.0588Z",
    fill: "#121B26"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2353 47.0589H22.3529V34.7059H10V38.8236H18.2353V47.0589Z",
    fill: "#121B26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4707 26.4706H30.5884V34.7059H26.4707V26.4706Z",
    fill: "#121B26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7061 34.7059H45.0002V38.8236H34.7061V34.7059Z",
    fill: "#121B26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8237 22.353H45.0002V18.2354H34.7061V30.5883H38.8237V22.353Z",
    fill: "#121B26"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45 10H55.2941V14.1176H45V10Z",
    fill: "#121B26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1176 14.1176H22.3529V10H10V22.3529H14.1176V14.1176Z",
    fill: "#121B26"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7061 10H40.8825V14.1176H34.7061V10Z",
    fill: "#121B26"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2354 22.3529H30.5883V10H26.4706V18.2353H18.2354V22.3529Z",
    fill: "#121B26"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.4706H22.3529V30.5882H10V26.4706Z",
    fill: "#121B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QrCode.2568338db45c24aabdf668c60620f12a.svg";
export { ForwardRef as ReactComponent };